export const translations = {
  en: {
    common: {
      loading: 'Loading...',
      refresh: 'Refresh',
      edit: 'Edit',
      view: 'View',
      save: 'Save',
      cancel: 'Cancel',
      delete: 'Delete',
      create: 'Create',
      update: 'Update',
      confirm: 'Confirm',
      close: 'Close',
      search: 'Search',
      filter: 'Filter',
      actions: 'Actions',
      status: 'Status',
      name: 'Name',
      description: 'Description',
      price: 'Price',
      category: 'Category',
      image: 'Image',
      created: 'Created',
      updated: 'Updated',
      clear: 'Clear',
      previous: 'Previous',
      next: 'Next'
    },
    dashboard: {
      title: 'Dashboard',
      welcome: 'Welcome to your dashboard',
      total: 'Total',
      totalProducts: 'Total Products',
      activeProducts: 'Active Products',
      inactiveProducts: 'Inactive Products',
      totalCategories: 'Total Categories',
      recentProducts: 'Recent Products',
      failedToLoad: 'Failed to load dashboard statistics'
    },
    products: {
      title: 'Products',
      productList: 'Product List',
      addProduct: 'Add Product',
      editProduct: 'Edit Product',
      deleteProduct: 'Delete Product',
      noProducts: 'No products found',
      active: 'Active',
      inactive: 'Inactive',
      searchProducts: 'Search products...',
      deleteConfirmTitle: 'Delete Product',
      deleteConfirmMessage: 'Are you sure you want to delete this product? This action cannot be undone.',
      productImages: 'Product Images',
      mainImage: 'Main Image',
      galleryImages: 'Gallery Images',
      uploadMainImage: 'Upload Main Image',
      uploadGalleryImages: 'Upload Gallery Images (Multiple)',
      imageFormats: 'Supported formats',
      maxSize: 'Maximum size',
      multipleImagesHint: 'You can select multiple images at once',
      firstImageHint: 'The first image in the gallery will be used as the main/featured image',
      invalidImageType: 'Invalid file type. Only JPEG, PNG, GIF, and WebP are allowed',
      imageTooLarge: 'Image size too large. Maximum 5MB per image',
      imageUploadSuccess: 'Images uploaded successfully',
      imageUploadError: 'Failed to upload images'
    },
    navigation: {
      dashboard: 'Dashboard',
      products: 'Products',
      categories: 'Categories',
      orders: 'Orders',
      clients: 'Clients',
      discounts: 'Discounts',
      cities: 'Cities',
      roles: 'Roles'
    },
    mediaLibrary: {
      title: 'Media Library',
      browseLibrary: 'Browse Library',
      search: 'Search images...',
      noImages: 'No images found',
      attachSelected: 'Attach Selected',
      viewUsage: 'View Usage',
      imageUsage: 'Image Usage',
      totalUsage: 'Total Usage',
      deleteConfirm: 'Are you sure you want to delete this image? It will be removed from all products using it.',
      deleteError: 'Failed to delete image',
      attachError: 'Failed to attach image from library',
      saveProductFirst: 'Please save the product first before browsing the media library',
      duplicateDetected: 'This image already exists in the library',
      alreadyAttached: 'This image is already attached to this product',
      imageAdded: 'Image added from library successfully'
    },
    categories: {
      title: 'Categories',
      categoryList: 'Category List',
      manageCategories: 'Manage Categories',
      addCategory: 'Add Category',
      editCategory: 'Edit Category',
      deleteCategory: 'Delete Category',
      createNewCategory: 'Create New Category',
      updateCategoryInfo: 'Update category information',
      addNewCategory: 'Add new category details',
      categoryName: 'Category Name',
      enterCategoryName: 'Enter category name',
      slug: 'Slug',
      enterSlug: 'Enter slug',
      slugAutoGenerate: 'Leave empty to auto-generate from name',
      description: 'Description',
      enterDescription: 'Enter category description',
      parentCategory: 'Parent Category',
      noneTopLevel: 'None (Top Level)',
      subcategories: 'Subcategories',
      noCategories: 'No categories found',
      noCategoriesFound: 'No categories found',
      categoriesWillBeDisplayed: 'Categories will be displayed here when added.',
      loadingCategories: 'Loading categories...',
      retry: 'Retry',
      saving: 'Processing...',
      failedToLoad: 'Failed to load categories',
      failedToSave: 'Failed to save category',
      failedToDelete: 'Failed to delete category',
      deleteConfirm: 'Are you sure you want to delete this category?',
      cannotConnect: 'Cannot connect to server:',
      backToCategories: 'Back to Categories',
      categoryInformation: 'Category Information',
      fillCategoryDetails: 'Fill in the category details below',
      icon: 'Icon',
      selectIcon: 'Select Category Icon',
      searchIcons: 'Search icons...',
      loadingIcons: 'Loading icons...',
      noIconsFound: 'No icons found',
      noIconSelected: 'No icon selected',
      clickToSelectIcon: 'Click to select an icon'
    },
    orders: {
      title: 'Orders',
      manageOrders: 'Manage Orders',
      orderList: 'Order List',
      noOrders: 'No orders found',
      orderNumber: 'Order Number',
      customer: 'Customer',
      date: 'Date',
      total: 'Total',
      status: 'Status',
      paymentStatus: 'Payment Status',
      actions: 'Actions',
      view: 'View',
      updateStatus: 'Update Status',
      orderStatus: 'Order Status',
      orderDetails: 'Order Details',
      orderInformation: 'Order Information',
      referenceNumber: 'Reference Number',
      paymentMethod: 'Payment Method',
      cardPayment: 'Credit Card',
      cashOnDelivery: 'Cash on Delivery',
      closestPoint: 'Closest Point',
      shippingAddress: 'Shipping Address',
      noAddress: 'No address provided',
      orderItems: 'Order Items',
      product: 'Product',
      variant: 'Variant',
      quantity: 'Quantity',
      price: 'Price',
      subtotal: 'Subtotal',
      discount: 'Discount',
      searchOrder: 'Search',
      searchPlaceholder: 'Search by order number or customer name...',
      allStatuses: 'All Statuses',
      pending: 'Pending',
      processing: 'Processing',
      shipped: 'Shipped',
      delivered: 'Delivered',
      cancelled: 'Cancelled',
      allPayments: 'All Payments',
      paymentPending: 'Pending',
      paymentPaid: 'Paid',
      paymentFailed: 'Failed',
      print: 'Print',
      showing: 'Showing',
      to: 'to',
      of: 'of',
      orders: 'orders',
      failedToLoad: 'Failed to load orders',
      failedToLoadDetails: 'Failed to load order details',
      failedToUpdate: 'Failed to update order status',
      failedToDelete: 'Failed to delete order',
      confirmDeleteTitle: 'Confirm Deletion',
      confirmDeleteDesc: 'Are you sure you want to delete this order? The order will be soft deleted and can be restored later.'
    },
    settings: {
      title: 'Settings',
      subtitle: 'App Settings',
      generalSettings: 'General Settings',
      profile: 'Profile',
      preferences: 'Preferences'
    },
    clients: {
      title: 'Clients',
      manageClients: 'Manage Clients',
      addClient: 'Add Client',
      addFirstClient: 'Add First Client', 
      searchClient: 'Search Client',
      searchPlaceholder: 'Search by name, email, phone or city...',
      noClients: 'No clients found',
      getStarted: 'Create your first client to get started.',
      name: 'Name',
      email: 'Email',
      phone: 'Phone',
      city: 'City',
      status: 'Status',
      joinDate: 'Join Date',
      active: 'Active',
      inactive: 'Inactive',
      activate: 'Activate',
      deactivate: 'Deactivate',
      allStatuses: 'All Statuses',
      allCities: 'All Cities',
      deleteConfirmation: 'Are you sure you want to delete client "{name}"?',
      deleteWarning: 'This action cannot be undone.'
    },
    cities: {
      title: 'Cities & Shipping',
      manageCitiesAndShipping: 'Manage Cities and Shipping Prices',
      addCity: 'Add City',
      addFirstCity: 'Add First City',
      editCity: 'Edit City',
      createCity: 'Create City',
      createCityDescription: 'City creation form will be available soon.',
      editCityDescription: 'City editing form will be available soon.',
      backToCities: 'Back to Cities',
      searchCity: 'Search City',
      searchPlaceholder: 'Search by city name, code, or country...',
      noCities: 'No cities found',
      getStarted: 'Create your first city to get started.',
      name: 'City Name',
      code: 'City Code',
      label: 'Display Label',
      country: 'Country',
      shippingPrice: 'Shipping Price',
      newShippingPrice: 'New Shipping Price',
      minShippingPrice: 'Min Price',
      maxShippingPrice: 'Max Price',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      activate: 'Activate',
      deactivate: 'Deactivate',
      activeStatus: 'Active Status',
      allStatuses: 'All Statuses',
      allCountries: 'All Countries',
      totalCities: 'Total Cities',
      averageShipping: 'Average Shipping',
      minShipping: 'Min Shipping',
      maxShipping: 'Max Shipping',
      bulkUpdateShipping: 'Bulk Update Shipping',
      bulkUpdateDescription: 'Update shipping prices for selected cities.',
      updatePrices: 'Update Prices',
      nameRequired: 'City name is required',
      shippingPriceRequired: 'Shipping price must be 0 or greater',
      deleteConfirmation: 'Are you sure you want to delete city "{name}"?',
      deleteWarning: 'This action cannot be undone and will affect all related orders.',
      shippingCalculator: 'Shipping Calculator',
      cartTotal: 'Cart Total',
      citySelection: 'Select City',
      applyFreeShipping: 'Apply Free Shipping Threshold',
      calculatedShipping: 'Calculated Shipping Cost',
      finalTotal: 'Final Total',
      sortBy: 'Sort By',
      sortByName: 'Name',
      sortByPrice: 'Shipping Price',
      sortByCountry: 'Country',
      sortByDate: 'Date Created',
      sortByCode: 'City Code',
      freeShippingFilter: 'Free Shipping',
      allShippingTypes: 'All Types',
      freeShippingOnly: 'Free Shipping Only',
      paidShippingOnly: 'Paid Shipping Only',
      dateFrom: 'Date From',
      dateTo: 'Date To',
      itemsPerPage: 'Items Per Page',
      showingResults: 'Showing {from} to {to} of {total} results'
    },
    discounts: {
      title: 'Discounts & Coupons',
      manageDiscounts: 'Manage Discount Codes and Coupons',
      addDiscount: 'Add Discount',
      addFirstDiscount: 'Add First Discount',
      editDiscount: 'Edit Discount',
      createDiscount: 'Create Discount',
      createDiscountDescription: 'Discount creation form will be available soon.',
      editDiscountDescription: 'Discount editing form will be available soon.',
      backToDiscounts: 'Back to Discounts',
      searchDiscount: 'Search Discount',
      searchPlaceholder: 'Search by code, type, or value...',
      noDiscounts: 'No discounts found',
      getStarted: 'Create your first discount to get started.',
      code: 'Discount Code',
      discountCode: 'Discount Code',
      type: 'Type',
      value: 'Value',
      percentageValue: 'Percentage (%)',
      fixedValue: 'Fixed Amount (IQD)',
      minOrder: 'Min Order',
      minOrderAmount: 'Minimum Order Amount',
      maxUses: 'Max Uses',
      maxUsesHint: 'Leave empty for unlimited uses',
      uses: 'Uses',
      unlimited: 'Unlimited',
      validity: 'Validity',
      startDate: 'Start Date',
      endDate: 'End Date',
      status: 'Status',
      active: 'Active',
      inactive: 'Inactive',
      expired: 'Expired',
      scheduled: 'Scheduled',
      isActive: 'Is Active',
      activeOnly: 'Active Only',
      allStatuses: 'All Statuses',
      allTypes: 'All Types',
      percentageType: 'Percentage',
      fixedType: 'Fixed Amount',
      totalDiscounts: 'Total Discounts',
      activeDiscounts: 'Active Discounts',
      expiredDiscounts: 'Expired Discounts',
      topUsage: 'Most Used',
      validateCode: 'Validate Code',
      validate: 'Validate',
      validDiscount: 'Valid Discount!',
      invalidDiscount: 'Invalid Discount',
      orderAmount: 'Order Amount',
      discountAmount: 'Discount Amount',
      finalAmount: 'Final Amount',
      validationError: 'Validation failed',
      generateCode: 'Generate',
      deleteDiscount: 'Delete Discount',
      deleteConfirmation: 'Are you sure you want to delete discount code "{code}"?',
      deleteWarning: 'This action cannot be undone and will affect all related orders.',
      codeRequired: 'Discount code is required',
      typeRequired: 'Discount type is required',
      valueRequired: 'Discount value is required',
      percentageRange: 'Percentage must be between 0 and 100',
      positiveValue: 'Value must be positive',
      startDateRequired: 'Start date is required',
      endDateRequired: 'End date is required',
      sortBy: 'Sort By',
      sortByCode: 'Code',
      sortByType: 'Type',
      sortByValue: 'Value',
      sortByUses: 'Uses Count',
      sortByDate: 'Date Created',
      dateFrom: 'Date From',
      dateTo: 'Date To',
      itemsPerPage: 'Items Per Page',
      showingResults: 'Showing {from} to {to} of {total} results'
    },
    roles: {
      title: 'Roles & Permissions',
      manageRoles: 'Manage User Roles and Permissions',
      addRole: 'Add Role',
      addFirstRole: 'Add First Role',
      editRole: 'Edit Role',
      createRole: 'Create Role',
      createRoleDescription: 'Role creation form will be available soon.',
      editRoleDescription: 'Role editing form will be available soon.',
      editingRole: 'Editing Role',
      backToRoles: 'Back to Roles',
      searchRole: 'Search Role',
      searchPlaceholder: 'Search by role name or permissions...',
      noRoles: 'No roles found',
      getStarted: 'Create your first role to get started.',
      roleName: 'Role Name',
      displayName: 'Display Name',
      description: 'Description',
      guardName: 'Guard Name',
      permissions: 'Permissions',
      users: 'Users',
      totalRoles: 'Total Roles',
      activeRoles: 'Active Roles',
      totalPermissions: 'Total Permissions',
      userAssignments: 'User Assignments',
      managePermissions: 'Manage Permissions',
      manageRolePermissions: 'Manage Permissions for {role}',
      savePermissions: 'Save Permissions',
      roleUsers: 'Users with {role} Role',
      noUsersAssigned: 'No users assigned to this role',
      deleteRole: 'Delete Role',
      deleteConfirmation: 'Are you sure you want to delete role "{name}"?',
      deleteWarning: 'This action cannot be undone and will remove this role from all assigned users.',
      roleNameRequired: 'Role name is required',
      sortBy: 'Sort By',
      sortByName: 'Name',
      sortByUsersCount: 'Users Count',
      sortByPermissionsCount: 'Permissions Count',
      sortByDate: 'Date Created',
      itemsPerPage: 'Items Per Page',
      showingResults: 'Showing {from} to {to} of {total} results'
    }
  },
  ar: {
    common: {
      loading: 'جاري التحميل...',
      refresh: 'تحديث',
      edit: 'تعديل',
      view: 'عرض',
      save: 'حفظ',
      cancel: 'إلغاء',
      delete: 'حذف',
      create: 'إنشاء',
      update: 'تحديث',
      confirm: 'تأكيد',
      close: 'إغلاق',
      search: 'بحث',
      filter: 'تصفية',
      actions: 'الإجراءات',
      status: 'الحالة',
      name: 'الاسم',
      description: 'الوصف',
      price: 'السعر',
      category: 'الفئة',
      image: 'الصورة',
      created: 'تاريخ الإنشاء',
      updated: 'تاريخ التحديث',
      clear: 'مسح',
      previous: 'السابق',
      next: 'التالي'
    },
    dashboard: {
      title: 'لوحة التحكم',
      welcome: 'مرحباً بك في لوحة التحكم',
      total: 'الإجمالي',
      totalProducts: 'إجمالي المنتجات',
      activeProducts: 'المنتجات النشطة',
      inactiveProducts: 'المنتجات غير النشطة',
      totalCategories: 'إجمالي الفئات',
      recentProducts: 'المنتجات الأخيرة',
      failedToLoad: 'فشل تحميل إحصائيات لوحة التحكم'
    },
    products: {
      title: 'المنتجات',
      productList: 'قائمة المنتجات',
      addProduct: 'إضافة منتج',
      editProduct: 'تعديل المنتج',
      deleteProduct: 'حذف المنتج',
      noProducts: 'لا توجد منتجات',
      active: 'نشط',
      inactive: 'غير نشط',
      searchProducts: 'البحث عن منتج...',
      deleteConfirmTitle: 'حذف المنتج',
      deleteConfirmMessage: 'هل أنت متأكد من رغبتك في حذف هذا المن�ج؟ لا يمكن التراجع عن هذا الإجراء.',
      productImages: 'صور المنتج',
      mainImage: 'الصورة الرئيسية',
      galleryImages: 'معرض الصور',
      uploadMainImage: 'رفع الصورة الرئيسية',
      uploadGalleryImages: 'رفع صور المعرض (متعددة)',
      imageFormats: 'الصيغ المدعومة',
      maxSize: 'الحجم الأقصى',
      multipleImagesHint: 'يمكنك اختيار صور متعددة دفعة واحدة',
      firstImageHint: 'سيتم استخدام الصورة الأولى في المعرض كصورة رئيسية',
      invalidImageType: 'نوع الملف غير صحيح. فقط JPEG و PNG و GIF و WebP مسموح',
      imageTooLarge: 'حجم الصورة كبير جداً. الحد الأقصى 5 ميجابايت لكل صورة',
      imageUploadSuccess: 'تم رفع الصور بنجاح',
      imageUploadError: 'فشل رفع الصور'
    },
    navigation: {
      dashboard: 'لوحة التحكم',
      products: 'المنتجات',
      categories: 'الفئات',
      orders: 'الطلبات',
      clients: 'العملاء', 
      discounts: 'الخصومات',
      cities: 'المدن',
      roles: 'الأدوار'
    },
    mediaLibrary: {
      title: 'مكتبة الوسائط',
      browseLibrary: 'تصفح المكتبة',
      search: 'البحث عن الصور...',
      noImages: 'لا توجد صور',
      attachSelected: 'إرفاق المحدد',
      viewUsage: 'عرض الاستخدام',
      imageUsage: 'استخدام الصورة',
      totalUsage: 'إجمالي الاستخدام',
      deleteConfirm: 'هل أنت متأكد من حذف هذه الصورة؟ سيتم إزالتها من جميع المنتجات التي تستخدمها.',
      deleteError: 'فشل في حذف الصورة',
      attachError: 'فشل في إرفاق الصورة من المكتبة',
      saveProductFirst: 'يرجى حفظ المنتج أولاً قبل تصفح مكتبة الوسائط',
      duplicateDetected: 'هذه الصورة موجودة بالفعل في المكتبة',
      alreadyAttached: 'هذه الصورة مرفقة بالفعل بهذا المنتج',
      imageAdded: 'تمت إضافة الصورة من المكتبة بنجاح'
    },
    categories: {
      title: 'الفئات',
      categoryList: 'قائمة الفئات',
      manageCategories: 'إدارة الفئات',
      addCategory: 'إضافة فئة',
      editCategory: 'تعديل الفئة',
      deleteCategory: 'حذف الفئة',
      createNewCategory: 'إنشاء فئة جديدة',
      updateCategoryInfo: 'تحديث معلومات الفئة',
      addNewCategory: 'إضافة تفاصيل الفئة الجديدة',
      categoryName: 'اسم الفئة',
      enterCategoryName: 'أدخل اسم الفئة',
      slug: 'الرمز',
      enterSlug: 'أدخل الرمز',
      slugAutoGenerate: 'اتركه فارغاً ليتم إنشاؤه تلقائياً من الاسم',
      description: 'الوصف',
      enterDescription: 'أدخل وصف الفئة',
      parentCategory: 'الفئة الأساسية',
      noneTopLevel: 'لا شيء (المستوى الأعلى)',
      subcategories: 'الفئات الفرعية',
      noCategories: 'لا توجد فئات',
      noCategoriesFound: 'لا توجد فئات',
      categoriesWillBeDisplayed: 'ستظهر الفئات هنا عند إضافتها.',
      loadingCategories: 'جاري تحميل الفئات...',
      retry: 'إعادة المحاولة',
      saving: 'جارٍ التنفيذ...',
      failedToLoad: 'فشل في تحميل الفئات',
      failedToSave: 'فشل في حفظ الفئة',
      failedToDelete: 'فشل في حذف الفئة',
      deleteConfirm: 'هل أنت متأكد من حذف هذه الفئة؟',
      cannotConnect: 'لا يمكن الاتصال بالخادم:',
      backToCategories: 'العودة إلى الفئات',
      categoryInformation: 'معلومات الفئة',
      fillCategoryDetails: 'أدخل تفاصيل الفئة أدناه',
      icon: 'الأيقونة',
      selectIcon: 'اختر أيقونة الفئة',
      searchIcons: 'بحث عن الأيقونات...',
      loadingIcons: 'جاري تحميل الأيقونات...',
      noIconsFound: 'لم يتم العثور على أيقونات',
      noIconSelected: 'لم يتم اختيار أيقونة',
      clickToSelectIcon: 'انقر لاختيار أيقونة'
    },
    orders: {
      title: 'الطلبات',
      manageOrders: 'إدارة الطلبات',
      orderList: 'قائمة الطلبات',
      noOrders: 'لا توجد طلبات',
      orderNumber: 'رقم الطلب',
      customer: 'العميل',
      date: 'التاريخ',
      total: 'المجموع',
      status: 'الحالة',
      paymentStatus: 'حالة الدفع',
      actions: 'الإجراءات',
      view: 'عرض',
      updateStatus: 'تحديث الحالة',
      orderStatus: 'حالة الطلب',
      orderDetails: 'تفاصيل الطلب',
      orderInformation: 'معلومات الطلب',
      referenceNumber: 'الرقم المرجعي',
      paymentMethod: 'طريقة الدفع',
      cardPayment: 'بطاقة ائتمان',
      cashOnDelivery: 'الدفع عند الاستلام',
      closestPoint: 'أقرب نقطة',
      shippingAddress: 'عنوان الشحن',
      noAddress: 'لم يتم توفير عنوان',
      orderItems: 'عناصر الطلب',
      product: 'المنتج',
      variant: 'الصنف',
      quantity: 'الكمية',
      price: 'السعر',
      subtotal: 'المجموع الفرعي',
      discount: 'الخصم',
      searchOrder: 'بحث',
      searchPlaceholder: 'البحث برقم الطلب أو اسم العميل...',
      allStatuses: 'جميع الحالات',
      pending: 'قيد الانتظار',
      processing: 'قيد المعالجة',
      shipped: 'تم الشحن',
      delivered: 'تم التوصيل',
      cancelled: 'ملغي',
      allPayments: 'جميع حالات الدفع',
      paymentPending: 'قيد الانتظار',
      paymentPaid: 'مدفوع',
      paymentFailed: 'فشل',
      print: 'طباعة',
      showing: 'عرض',
      to: 'إلى',
      of: 'من',
      orders: 'طلبات',
      failedToLoad: 'فشل تحميل الطلبات',
      failedToLoadDetails: 'فشل تحميل تفاصيل الطلب',
      failedToUpdate: 'فشل تحديث حالة الطلب',
      failedToDelete: 'فشل حذف الطلب',
      confirmDeleteTitle: 'تأكيد الحذف',
      confirmDeleteDesc: 'هل أنت متأكد من حذف هذا الطلب؟ سيتم حذف الطلب بشكل ناعم ويمكن استعادته لاحقًا.'
    },
    settings: {
      title: 'الإعدادات',
      subtitle: 'إعدادات التطبيق',
      generalSettings: 'الإعدادات العامة',
      profile: 'الملف الشخصي',
      preferences: 'التفضيلات'
    },
    clients: {
      title: 'العملاء',
      manageClients: 'إدارة العملاء',
      addClient: 'إضافة عميل',
      addFirstClient: 'إضافة أول عميل',
      searchClient: 'البحث عن عميل',
      searchPlaceholder: 'البحث بالاسم، البريد الإلكتروني، الهاتف أو المدينة...',
      noClients: 'لا يوجد عملاء',
      getStarted: 'أنشئ عميلك الأول للبدء.',
      name: 'الاسم',
      email: 'البريد الإلكتروني',
      phone: 'الهاتف',
      city: 'المدينة',
      status: 'الحالة',
      joinDate: 'تاريخ الانضمام',
      active: 'نشط',
      inactive: 'غير نشط',
      activate: 'تفعيل',
      deactivate: 'إلغاء التفعيل',
      allStatuses: 'جميع الحالات',
      allCities: 'جميع المدن',
      deleteConfirmation: 'هل أنت متأكد من حذف العميل "{name}"؟',
      deleteWarning: 'لا يمكن التراجع عن هذا الإجراء.'
    },
    cities: {
      title: 'المدن والشحن',
      manageCitiesAndShipping: 'إدارة المدن وأسعار الشحن',
      addCity: 'إضافة مدينة',
      addFirstCity: 'إضافة أول مدينة',
      editCity: 'تعديل المدينة',
      createCity: 'إنشاء مدينة',
      createCityDescription: 'نموذج إنشاء المدينة سيكون متاحاً قريباً.',
      editCityDescription: 'نموذج تحرير المدينة سيكون متاحاً قريباً.',
      backToCities: 'العودة إلى المدن',
      searchCity: 'البحث عن مدينة',
      searchPlaceholder: 'البحث باسم المدينة، الكود أو البلد...',
      noCities: 'لا توجد مدن',
      getStarted: 'أنشئ مدينتك الأولى للبدء.',
      name: 'اسم المدينة',
      code: 'كود المدينة',
      label: 'العنوان المعروض',
      country: 'البلد',
      shippingPrice: 'سعر الشحن',
      newShippingPrice: 'سعر الشحن الجديد',
      minShippingPrice: 'أقل سعر',
      maxShippingPrice: 'أعلى سعر',
      status: 'الحالة',
      active: 'نشط',
      inactive: 'غير نشط',
      activate: 'تفعيل',
      deactivate: 'إلغاء التفعيل',
      activeStatus: 'الحالة النشطة',
      allStatuses: 'جميع الحالات',
      allCountries: 'جميع البلدان',
      totalCities: 'إجمالي المدن',
      averageShipping: 'متوسط الشحن',
      minShipping: 'أقل شحن',
      maxShipping: 'أعلى شحن',
      bulkUpdateShipping: 'تحديث جماعي للشحن',
      bulkUpdateDescription: 'تحديث أسعار الشحن للمدن المختارة.',
      updatePrices: 'تحديث الأسعار',
      nameRequired: 'اسم المدينة مطلوب',
      shippingPriceRequired: 'يجب أن يكون سعر الشحن 0 أو أكثر',
      deleteConfirmation: 'هل أنت متأكد من حذف المدينة "{name}"؟',
      deleteWarning: 'لا يمكن التراجع عن هذا الإجراء وسيؤثر على جميع الطلبات المرتبطة.',
      shippingCalculator: 'حاسبة الشحن',
      cartTotal: 'إجمالي السلة',
      citySelection: 'اختر المدينة',
      applyFreeShipping: 'تطبيق حد الشحن المجاني',
      calculatedShipping: 'تكلفة الشحن المحسوبة',
      finalTotal: 'المجموع النهائي',
      sortBy: 'ترتيب حسب',
      sortByName: 'الاسم',
      sortByPrice: 'سعر الشحن',
      sortByCountry: 'البلد',
      sortByDate: 'تاريخ الإنشاء',
      sortByCode: 'كود المدينة',
      freeShippingFilter: 'الشحن المجاني',
      allShippingTypes: 'جميع الأنواع',
      freeShippingOnly: 'الشحن المجاني فقط',
      paidShippingOnly: 'الشحن المدفوع فقط',
      dateFrom: 'من تاريخ',
      dateTo: 'إلى تاريخ',
      itemsPerPage: 'عناصر في الصفحة',
      showingResults: 'عرض {from} إلى {to} من {total} نتيجة'
    },
    discounts: {
      title: 'الخصومات والكوبونات',
      manageDiscounts: 'إدارة أكواد الخصم والكوبونات',
      addDiscount: 'إضافة خصم',
      addFirstDiscount: 'إضافة أول خصم',
      editDiscount: 'تعديل الخصم',
      createDiscount: 'إنشاء خصم',
      createDiscountDescription: 'نموذج إنشاء الخصم سيكون متاحاً قريباً.',
      editDiscountDescription: 'نموذج تعديل الخصم سيكون متاحاً قريباً.',
      backToDiscounts: 'العودة إلى الخصومات',
      searchDiscount: 'البحث عن خصم',
      searchPlaceholder: 'البحث بالكود، النوع، أو القيمة...',
      noDiscounts: 'لا توجد خصومات',
      getStarted: 'أنشئ خصمك الأول للبدء.',
      code: 'كود الخصم',
      discountCode: 'كود الخصم',
      type: 'النوع',
      value: 'القيمة',
      percentageValue: 'النسبة المئوية (%)',
      fixedValue: 'المبلغ الثابت (دينار)',
      minOrder: 'أقل طلب',
      minOrderAmount: 'أقل مبلغ للطلب',
      maxUses: 'أقصى استخدام',
      maxUsesHint: 'اتركه فارغاً للاستخدام غير المحدود',
      uses: 'الاستخدامات',
      unlimited: 'غير محدود',
      validity: 'الصلاحية',
      startDate: 'تاريخ البداية',
      endDate: 'تاريخ النهاية',
      status: 'الحالة',
      active: 'نشط',
      inactive: 'غير نشط',
      expired: 'منتهي الصلاحية',
      scheduled: 'مجدول',
      isActive: 'نشط',
      activeOnly: 'النشط فقط',
      allStatuses: 'جميع الحالات',
      allTypes: 'جميع الأنواع',
      percentageType: 'نسبة مئوية',
      fixedType: 'مبلغ ثابت',
      totalDiscounts: 'إجمالي الخصومات',
      activeDiscounts: 'الخصومات النشطة',
      expiredDiscounts: 'الخصومات المنتهية',
      topUsage: 'الأكثر استخداماً',
      validateCode: 'التحقق من الكود',
      validate: 'تحقق',
      validDiscount: 'خصم صالح!',
      invalidDiscount: 'خصم غير صالح',
      orderAmount: 'مبلغ الطلب',
      discountAmount: 'مبلغ الخصم',
      finalAmount: 'المبلغ النهائي',
      validationError: 'فشل التحقق',
      generateCode: 'توليد',
      deleteDiscount: 'حذف الخصم',
      deleteConfirmation: 'هل أنت متأكد من حذف كود الخصم "{code}"؟',
      deleteWarning: 'لا يمكن التراجع عن هذا الإجراء وسيؤثر على جميع الطلبات المرتبطة.',
      codeRequired: 'كود الخصم مطلوب',
      typeRequired: 'نوع الخصم مطلوب',
      valueRequired: 'قيمة الخصم مطلوبة',
      percentageRange: 'النسبة المئوية يجب أن تكون بين 0 و 100',
      positiveValue: 'القيمة يجب أن تكون موجبة',
      startDateRequired: 'تاريخ البداية مطلوب',
      endDateRequired: 'تاريخ النهاية مطلوب',
      sortBy: 'ترتيب حسب',
      sortByCode: 'الكود',
      sortByType: 'النوع',
      sortByValue: 'القيمة',
      sortByUses: 'عدد الاستخدامات',
      sortByDate: 'تاريخ الإنشاء',
      dateFrom: 'من تاريخ',
      dateTo: 'إلى تاريخ',
      itemsPerPage: 'عناصر في الصفحة',
      showingResults: 'عرض {from} إلى {to} من {total} نتيجة'
    },
    roles: {
      title: 'الأدوار والصلاحيات',
      manageRoles: 'إدارة أدوار المستخدمين والصلاحيات',
      addRole: 'إضافة دور',
      addFirstRole: 'إضافة أول دور',
      editRole: 'تعديل الدور',
      createRole: 'إنشاء دور',
      createRoleDescription: 'نموذج إنشاء الدور سيكون متاحاً قريباً.',
      editRoleDescription: 'نموذج تعديل الدور سيكون متاحاً قريباً.',
      editingRole: 'تعديل الدور',
      backToRoles: 'العودة إلى الأدوار',
      searchRole: 'البحث عن دور',
      searchPlaceholder: 'البحث باسم الدور أو الصلاحيات...',
      noRoles: 'لا توجد أدوار',
      getStarted: 'أنشئ دورك الأول للبدء.',
      roleName: 'اسم الدور',
      displayName: 'الاسم المعروض',
      description: 'الوصف',
      guardName: 'اسم الحارس',
      permissions: 'الصلاحيات',
      users: 'المستخدمين',
      totalRoles: 'إجمالي الأدوار',
      activeRoles: 'الأدوار النشطة',
      totalPermissions: 'إجمالي الصلاحيات',
      userAssignments: 'تعيينات المستخدمين',
      managePermissions: 'إدارة الصلاحيات',
      manageRolePermissions: 'إدارة صلاحيات دور {role}',
      savePermissions: 'حفظ الصلاحيات',
      roleUsers: 'المستخدمين مع دور {role}',
      noUsersAssigned: 'لم يتم تعيين مستخدمين لهذا الدور',
      deleteRole: 'حذف الدور',
      deleteConfirmation: 'هل أنت متأكد من حذف الدور "{name}"؟',
      deleteWarning: 'لا يمكن التراجع عن هذا الإجراء وسيتم إزالة هذا الدور من جميع المستخدمين المعينين.',
      roleNameRequired: 'اسم الدور مطلوب',
      sortBy: 'ترتيب حسب',
      sortByName: 'الاسم',
      sortByUsersCount: 'عدد المستخدمين',
      sortByPermissionsCount: 'عدد الصلاحيات',
      sortByDate: 'تاريخ الإنشاء',
      itemsPerPage: 'عناصر في الصفحة',
      showingResults: 'عرض {from} إلى {to} من {total} نتيجة'
    }
  }
}